/**
 * @generated SignedSource<<575d7cbba1b6de402b0ba3469c8aa8e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type IssueState = "CLOSED" | "OPEN" | "%future added value";
export type IssueStateReason = "COMPLETED" | "NOT_PLANNED" | "REOPENED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type IssuePickerIssue$data = {
  readonly closed: boolean;
  readonly databaseId: number | null | undefined;
  readonly id: string;
  readonly number: number;
  readonly state: IssueState;
  readonly stateReason: IssueStateReason | null | undefined;
  readonly title: string;
  readonly " $fragmentType": "IssuePickerIssue";
};
export type IssuePickerIssue$key = {
  readonly " $data"?: IssuePickerIssue$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssuePickerIssue">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "IssuePickerIssue"
};

(node as any).hash = "0da92fe190fa6afd16fd7b346174deb6";

export default node;
